import { FC, useCallback } from 'react';
import { useAuth, useDialog, useOneSignalCustomState, useSideMenu } from '@/logic/state';
import { useCheckClientCity, useUpdatePath } from '@/logic/hooks';

import shallow from 'zustand/shallow';
import { useInvalidateWallet } from '@/features/wallet/hooks/use-invalidate-wallet';
import { useLogout } from '@/logic/services';
import { ConfirmDialog } from '../shared/confirm-dialog';

const LogoutConfirmDialogIcon = '/icons/side-menu/logout-confirm-dialog-icon.svg';

export const LogoutConfirmDialog: FC = () => {
  const setDialog = useDialog(s => s.setDialog, shallow);
  const setSideMenu = useSideMenu(s => s.setSideMenu, shallow);
  const setUser = useAuth(s => s.setUser, shallow);
  const { checkGuestCity } = useCheckClientCity();
  const { updateLogoutPath } = useUpdatePath();

  const logout = useLogout();
  const { invalidateAllWallet } = useInvalidateWallet();
  const [deviceId] = useOneSignalCustomState(s => [s.muviDeviceId], shallow);

  const handleOkayClick = useCallback(() => {
    logout.safeMutateAsync(
      {
        headers: {
          'X-Device-Id': deviceId,
        },
      },
      {
        onSuccess: () => {
          setUser(null);
          checkGuestCity();
          setSideMenu(false);
          updateLogoutPath();
          setTimeout(() => {
            invalidateAllWallet();
          }, 1000);
        },
      }
    );
  }, [
    checkGuestCity,
    deviceId,
    invalidateAllWallet,
    logout,
    setSideMenu,
    setUser,
    updateLogoutPath,
  ]);

  return (
    <ConfirmDialog
      buttonId='logout-confirm-dialog'
      img={LogoutConfirmDialogIcon}
      widthImage='82px'
      heightImage='84px'
      altImage='alt.logout_icon'
      title='logout_confirm_dialog.title'
      description='logout_confirm_dialog.description'
      handleOkayClick={handleOkayClick}
      handleCloseClick={() => setDialog({})}
      isLoading={logout.isLoading}
    />
  );
};
